import apiService from './api.service';
import type { PolicyRegulation, RuleCategoryKey, RuleParamType, RuleSeverity } from '../types/policy.types';

export interface PublicCatalogParam {
  name: string;
  label: string;
  type: RuleParamType;
  default: number | string | string[] | null;
  description: string;
  min_value: number | null;
  max_value: number | null;
  unit: string | null;
}

export interface PublicCatalogRule {
  slug: string;
  name: string;
  description_short: string;
  description_long: string;
  category: RuleCategoryKey;
  severity_default: RuleSeverity;
  regulation_refs: PolicyRegulation[];
  tunable_params: PublicCatalogParam[];
}

export interface PublicCatalogCategory {
  category: RuleCategoryKey;
  label: string;
  rules: PublicCatalogRule[];
}

export interface PublicCatalogResponse {
  catalog_version: string;
  total_rules: number;
  categories: PublicCatalogCategory[];
}

class PublicCatalogService {
  async getCatalog(): Promise<PublicCatalogResponse> {
    const res = await apiService.client.get<PublicCatalogResponse>('/public/catalog');
    return res.data;
  }
}

export default new PublicCatalogService();
